
import ServicesModal from './servicesModal'

const Section2 = ({
  program,
  primaryConcern,
  residenceType,
  clientName,
  clientKey
}) => {
  return (
    <div className='section-2'>
      <div
        className='program'
        title='Program'
      >
        {program || 'No Program'}
      </div>

      <div
        className='concern'
        title='Primary Concern'
      >
        {primaryConcern || 'No Primary Concern'}
      </div>

      <div
        className='residence-type'
        title='Residence Type'
      >
        {residenceType || 'No Residence Type'}
      </div>

      <div className='client'>
        <ServicesModal
          name={clientName || 'N/A'}
          clientName={clientName}
          clientKey={clientKey}
        />
      </div>
    </div>
  )
}

export default Section2
